<template>
  <section class="app-ecommerce-details">
    <b-card
        v-if="product"
        no-body
    >
      <b-card-body>
        <b-row class="my-2">
          <!-- Left: Product Image Container -->
          <b-col
              cols="12"
              md="5"
              class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
          >
            <div class="d-flex align-items-center justify-content-center">
              <b-img
                  :src="product.imagen"
                  :alt="`Image of ${product.name}`"
                  class="product-img"
                  fluid
              />
            </div>
          </b-col>

          <!-- Right: Product Details -->
          <b-col
              cols="12"
              md="7"
          >
            <!-- Product Name -->
            <h4 class="font-weight-bolder" >{{ product.name }}</h4>
            <b-card-text class="item-company mb-0">
              <p class="company-name">
                <strong>{{ $t('Modelo') }}:</strong> {{ product.modelo }}
              </p>
            </b-card-text>
            <b-card-text class="item-company mb-0">
              <p class="company-name">
                <strong>{{ $t('codigoArticulo') }}:</strong> {{ product.codart }}
              </p>
            </b-card-text>
            <b-card-text class="item-company mb-0">
              <p class="company-name">
                <strong>{{ $t('ean13') }}:</strong> {{ product.ean13 }}
              </p>
            </b-card-text>
            <b-card-text
              class="item-company mb-0"
              v-if="product.manualUso || product.certificadoConformidad || product.fichaTecnica"
            >
              <p class="company-name">
                <a
                  :href="product.manualUso"
                  target="_blank"
                  v-if="product.manualUso"
                  class="mr-1 link"
                >
                  {{ $t('manualUso') }}
                </a>
                <a
                  :href="product.certificadoConformidad"
                  target="_blank"
                  v-if="product.certificadoConformidad"
                  class="mr-1 link"
                >
                  {{ $t('certificadoConformidad') }}
                </a>
                <a
                  :href="product.fichaTecnica"
                  target="_blank"
                  v-if="product.fichaTecnica"
                  class="mr-1 link"
                >
                  {{ $t('fichaTecnica') }}
                </a>
              </p>
            </b-card-text>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <ListAssets
      v-if="product.type === 'asset'"
      :productprop="this.$route.params.id"
      :showStadistics="false"
    />
    <ListEpis
      v-if="product.type === 'epi'"
      :productprop="this.$route.params.id"
      :showStadistics="false"
    />
    <ListInstallations
      v-if="product.type === 'installation'"
      :productprop="this.$route.params.id"
      :showStadistics="false"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BFormSelect, BTable, BPagination, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { TimestampToFlatPickr } from '@/libs/helpers'
import { config } from '@/shared/app.config'
import ListAssets from "@/views/assets/ListTable";
import ListEpis from "@/views/epis/ListTable";
import ListInstallations from "@/views/installations/ListTable";
export default {
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BLink,
    BFormSelect,
    BPagination,
    BBadge,
    ListAssets,
    ListEpis,
    ListInstallations,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      statusAssets: config.statusAssetsVariants,
      currentPage: 1,
      pageLength: 10,
      pages: ['10', '15', '25'],
      fields: [
        {
          label: this.$t('NombreProducto'),
          key: 'image',
        },
        {
          label: this.$t('Cliente'),
          key: 'client',
        },
        {
          label: this.$t('Estado'),
          key: 'status',
        },
        {
          label: this.$t('UltimaRevision'),
          key: 'last_review_date',
        },
        {
          label: this.$t('ProximaRevision'),
          key: 'next_review_date',
        },
        {
          label: this.$t('VidaUtil'),
          key: 'useful_life',
        },
        {
          label: this.$t('Acciones'),
          key: 'actions',
          class: 'text-right',
        },
      ],
    }
  },
  watch: {
    currentPage() {
      this.chargeData()
    },
    pageLength() {
      this.chargeData()
    },
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient',
      product: 'products/getProduct',
      items: 'assets/getItems',
      totalItems: 'assets/getTotalItems',
    }),
  },
  methods: {
    ...mapActions({
      getProduct: 'products/getProduct',
      getListAssets: 'assets/getListAssets',
    }),
  },
  async created() {
    await this.getProduct(this.$route.params.id)
  },
}
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
</style>
